export default {
  setWorkspaceArray (state, data) {
    state.workspaceArray = data;
  },
};